import React from 'react'
import { IoInformationCircleOutline } from "react-icons/io5";
import { Tooltip } from 'react-tooltip';
import { useNavigate } from 'react-router-dom';

export default function UserListAction(props) {

    const navigate = useNavigate()

    const report_page = () => {
        navigate('/user_report', { state: props.data })
    }

    return (
        <div>
            <IoInformationCircleOutline  size={20} className='eye'
                onClick={() => report_page()}
                data-tooltip-id="detail"
                data-tooltip-content="Details!"
                data-tooltip-place="bottom"
            />
            <Tooltip id="detail" style={{ backgroundColor: "rgb(34, 98, 198)", zIndex: '9', lineHeight: 'normal' }} />
        </div>
    )
}
